import {gsap} from "gsap";
import {HTH} from "../../HTH";
import {HTHGameMode} from "../../server/HTHGameMode";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {RestoreUtils} from "../../utils/RestoreUtils";
import {HTHSound} from "../../sound/HTHSound";

export class HTHSuperScatterToSafeConversion implements SimplePresentation {
    name: string = "HTHSuperScattertoSafeConversion";

    shouldRun(): boolean {
        return (!HTH.model.isNextNormal && HTH.model.nextMode !== HTHGameMode.NORMAL_AVALANCHE) && (HTH.model.isNormal || HTH.model.mode === HTHGameMode.NORMAL_AVALANCHE);
    }

    start(controller: SimplePresentationRunnerController): void {
        const convertTl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                HTH.screenInteractive.setInteractiveState(false);
                controller.finish();
            }
        });

        controller.setSkipCallback();
        HTH.screenInteractive.setInteractiveState(true);
        HTH.screenInteractive.clickArea.on('pointerdown', () => {
            HTH.screenInteractive.setInteractiveState(false);
            convertTl.timeScale(2);
        });

        convertTl.add(RestoreUtils.changeScatterSymbol("SA"));
        convertTl.add(() => {
             HTHSound.playTrack(HTHSound.SCATTER_TO_GOLD);
        }, "<");

        if (HTH.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            convertTl.timeScale(1.2);
        }

    }
}